import { ValidationSeverity } from '@k-ucap/shared';
import type { AnalysisIssue } from '@k-ucap/shared';

export type MuiChipColor = 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';

export const getSeverityColor = (severity: string): MuiChipColor => {
  switch (severity) {
    case ValidationSeverity.PASS:
      return 'success';
    case ValidationSeverity.WARN:
      return 'warning';
    case ValidationSeverity.FAIL:
      return 'error';
    case ValidationSeverity.UNKNOWN:
      return 'info';
    case ValidationSeverity.UNSUPPORTED:
      return 'default';
    case ValidationSeverity.INFO:
      return 'info';
    default:
      return 'default';
  }
};

export const getSeverityLabel = (severity: string): string => {
  switch (severity) {
    case ValidationSeverity.PASS:
      return 'PASS';
    case ValidationSeverity.WARN:
      return 'WARN';
    case ValidationSeverity.FAIL:
      return 'FAIL';
    case ValidationSeverity.UNKNOWN:
      return 'UNKNOWN';
    case ValidationSeverity.UNSUPPORTED:
      return 'UNSUPPORTED';
    case ValidationSeverity.INFO:
      return 'INFO';
    default:
      return severity;
  }
};

export const aggregateGroupSeverity = (issues: AnalysisIssue[]): string => {
  if (issues.length === 0) return ValidationSeverity.UNKNOWN;
  if (issues.some((i) => i.severity === ValidationSeverity.FAIL)) return ValidationSeverity.FAIL;
  if (issues.some((i) => i.severity === ValidationSeverity.UNSUPPORTED)) return ValidationSeverity.UNSUPPORTED;
  if (issues.some((i) => i.severity === ValidationSeverity.WARN)) return ValidationSeverity.WARN;
  if (issues.some((i) => i.severity === ValidationSeverity.UNKNOWN)) return ValidationSeverity.UNKNOWN;
  if (issues.some((i) => i.severity === ValidationSeverity.INFO)) return ValidationSeverity.INFO;
  return ValidationSeverity.PASS;
};
